import st from './index.module.css';
import Head from 'next/head';
import { Suspense, useEffect, useState } from 'react';
import VideoReviewsSlider from '../../components/sliders/VideoReviewsSlider';
import Review from '../../components/testimonals/review';
import TestimonalsAboutProject from '../../components/testimonals/TestimonialsAboutProject';
import ViewMore from '../../components/ViewMore';
import GetProposal from '../../components/proposal/ppc/GetProposal';
import axios from 'axios';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

const Testimonals = props => {
  const [active, setActive] = useState(1);
  const [showModalPPC, setShowModalPPC] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [aboutProjects, setAboutProjects] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [index, setIndex] = useState(6);

  const setHidden = () => {
    document.body.style.overflow = 'hidden';
  };
  const hideOfferModalPPC = () => {
    setShowModalPPC(false);
    document.getElementById('form-ppc').reset();
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const getAxios = () => {
    axios.get('https://admin.weprodigi.com/api/testimonials/get').then(response => {
      setTestimonials(response.data.services);
      setAboutProjects(response.data.testimonials);
    });
  };

  const showFiltersFunc = show => {
    if (event.target.classList.contains('overlay-filter') || event.target.classList.contains('overlay-filter')) {
      if (show) {
        setShowFilters(true);
        document.body.style.overflowY = 'hidden';
        document.body.style.overflowX = 'hidden';
      } else {
        setShowFilters(false);
        document.body.style.overflowY = 'auto';
        document.body.style.overflowX = 'auto';
      }
    }
  };

  useEffect(() => {
    getAxios();
  }, []);
  return (
    <>
      <Head>
        <title>Testimonials | Our clients feedbacks | Prodigi</title>
        <meta name="description" content="All our clients' reviews collected in one place. Over 120 testimonials on Clutch.co, Google, Facebook." />
        <meta property="og:url" content="https://weprodigi.com/testimonals" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Testimonials | Our clients feedbacks | Prodigi" />
        <meta
          property="og:description"
          content="All our clients' reviews collected in one place. Over 120 testimonials on Clutch.co, Google, Facebook."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/testimonals/meta.jpg" />
      </Head>
      <main>
        <div className={`relative w-full  h-700  overflow-hidden  ${st['bg-image']}`}>
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
              <h1 className="capitalize text-white text-30 md:text-60  font-bolder leading-none">
                International Agency <span className="leading-34 md:leading-none mt-10 md:mt-20 block">Trusted By 180 Companies</span>{' '}
              </h1>

              <div className="capitalize text-green text-30 md:text-60 leading-none  font-bolder mt-10 md:mt-20">Proofs are here</div>
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
              <div className={st.firefly} />
            </div>
          </div>
        </div>
        <div className="bg-white py-24">
          <div className="container">
            <p className={'text-16 leading-24 text-black'}>
              Instead of making promises, we provide proof. We greatly appreciate our clients for assisting us in creating the content on this
              webpage. Read and watch their testimonials to have complete confidence in choosing us as your partner.
            </p>
            <div className="mt-24 flex justify-between items-center gap-[6px]">
              <a area-label={'Link'} href="https://clutch.co/profile/weprodigi-agency#reviews" className={'pr-20 md:pr-5'} target={'_blank'}>
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/clutch.svg" width={200} alt="clutch" />
              </a>
              <a
                area-label={'Link'}
                className={'pr-20 md:pr-5'}
                href="https://www.google.com/maps/place/WeProdigi+-+Production+%26+Digital+Marketing+Agency/@40.1997698,44.5105341,17z/data=!4m7!3m6!1s0x406aa3e369ae5ccd:0x601e8f09360c508f!8m2!3d40.1997887!4d44.5105218!9m1!1b1"
                target={'_blank'}
              >
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/google.svg" width={110} alt="google" />
              </a>
              <a className={'pr-20 md:pr-5'} href="https://www.facebook.com/weprodigi/reviews/" target={'_blank'}>
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/facebook.svg" width={130} alt="facebook" />
              </a>
              <a className={''} href="https://www.goodfirms.co/company/weprodigi-marketing-agency" target={'_blank'}>
                <img src="/images/goodFirms.svg" width={220} alt="goodfirms" className="opacity-75" />
              </a>
              <a className={''} href="https://www.sortlist.com/agency/weprodigi-agency" target={'_blank'}>
                <img src="/images/sortlist.svg" width={110} alt="goodfirms" />
              </a>
            </div>
          </div>
        </div>
        <div className={'bg-gray-light'}>
          <div className="container py-24">
            <p className="text-black text-30 md:text-48 uppercase font-bolder mb-24 leading-none">Video Testimonials</p>
            <VideoReviewsSlider
              reviews={[
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/ppc/rev.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/ppc/Screenshot_1.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/ppc/healthline.svg',
                  position: 'Marketing Director |',
                  custommerName: 'Michael Holland',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/Flag_of_Canada_(Pantone).svg',
                  index: 1,
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/ZackFinal1.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/zach.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Vuit-logo2.png',
                  position: 'Founder |',
                  custommerName: 'Zach Marinello',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/uk.svg',
                  index: 2,
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/DianaFinal.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/diana.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Logo-Animation01.png',
                  position: 'Head of Marketing Department |',
                  custommerName: 'Diana Gaeta',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/ppc/us.svg',
                  index: 3,
                },
              ]}
            />
          </div>
        </div>
        <div className="bg-white">
          <div className="container py-24">
            <p className="text-black text-30 md:text-48 uppercase font-bolder leading-none">Testimonials by service</p>
          </div>
        </div>
        <div className="bg-white md:bg-gray-light h-auto md:h-64">
          <div className="container h-full hidden md:flex items-center">
            <div
              className={`h-full hover:bg-green-hover1 flex  items-center text-20 leading-24 border-b-2 px-15 cursor-pointer ${active == 1 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(1)}
            >
              ALL
            </div>
            <div
              className={`ml-64 h-full hover:bg-green-hover1 flex items-center text-20 leading-24 border-b-2 px-15 cursor-pointer ${active == 2 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(2)}
            >
              Video Production
            </div>
            <div
              className={`ml-64 h-full hover:bg-green-hover1 flex items-center text-20 leading-24 border-b-2 px-15 cursor-pointer ${active == 3 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(3)}
            >
              SMM
            </div>
            <div
              className={`ml-64 h-full hover:bg-green-hover1 flex items-center text-20 leading-24 border-b-2 px-15 cursor-pointer ${active == 4 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(4)}
            >
              Paid Advertising
            </div>
            <div
              className={`ml-64 h-full hover:bg-green-hover1 flex items-center text-20 leading-24 border-b-2 px-15 cursor-pointer ${active == 5 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(5)}
            >
              Design
            </div>
          </div>

          <div className=" container h-full flex md:hidden items-center justify-between">
            <div
              className={` h-full hover:bg-green-hover1 flex items-center text-20 leading-24 border-b-2  cursor-pointer ${active == 1 ? 'text-green-badge border-green-badge' : ' border-transparent '}`}
              onClick={() => setActive(1)}
            >
              All
            </div>

            <button
              onClick={() => showFiltersFunc(true)}
              className={'overlay-filter flex items-center  border-1 rounded-5 border-gray-headerIcon py-8 px-15'}
            >
              Filters
              <img
                src="https://admin.weprodigi.com/uploads/images/testimonals/filter.svg"
                className={'overlay-filter ml-10'}
                alt=""
                width={20}
                height={20}
              />
            </button>
          </div>
          <div className=" container h-full flex md:hidden items-center  bg-gray-light py-10 mt-10 justify-end">
            {active == 2 ? (
              <div className={'bg-white px-10 rounded-5 font-medium'}>
                Video Production{' '}
                <span className={'font-bolder'} onClick={() => setActive(1)}>
                  x
                </span>
              </div>
            ) : (
              ''
            )}
            {active == 3 ? (
              <div className={'bg-white px-10 rounded-5 font-bolder'}>
                SMM{' '}
                <span className={'font-bolder'} onClick={() => setActive(1)}>
                  x
                </span>
              </div>
            ) : (
              ''
            )}
            {active == 4 ? (
              <div className={'bg-white px-10 rounded-5 font-bolder'}>
                Paid Advertising{' '}
                <span className={'font-bolder'} onClick={() => setActive(1)}>
                  x
                </span>
              </div>
            ) : (
              ''
            )}
            {active == 5 ? (
              <div className={'bg-white  px-10 rounded-5 font-bolder'}>
                Design{' '}
                <span className={'font-bolder'} onClick={() => setActive(1)}>
                  x
                </span>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="bg-white">
          <div className={'container py-24 pt-10 md:pt-24  ' + st['grid-container']}>
            {active == 1 && (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 2 }}>
                <Masonry columnsCount={2} gutter={20}>
                  {testimonials.map((el, ind) => {
                    if (ind < index) {
                      return (
                        <div className={'bg-gray-light md:bg-white mt-20 grid-item ' + st.item} key={'review1' + ind}>
                          <Review data={el} />
                        </div>
                      );
                    }
                  })}
                </Masonry>
              </ResponsiveMasonry>
            )}
            {active == 2 && (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 2 }}>
                <Masonry columnsCount={2} gutter={20}>
                  {testimonials
                    .filter(el => el.category == 'video')
                    .map((el, ind) => {
                      if (ind < index) {
                        return (
                          <div className={'bg-gray-light md:bg-white mt-20 grid-item ' + st.item} key={'review2' + ind}>
                            <Review data={el} />
                          </div>
                        );
                      }
                    })}
                </Masonry>
              </ResponsiveMasonry>
            )}

            {active == 3 && (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 2 }}>
                <Masonry columnsCount={2} gutter={20}>
                  {testimonials
                    .filter(el => el.category == 'smm')
                    .map((el, ind) => {
                      if (ind < index) {
                        return (
                          <div className={'bg-gray-light md:bg-white mt-20 grid-item ' + st.item} key={'review2' + ind}>
                            <Review data={el} />
                          </div>
                        );
                      }
                    })}
                </Masonry>
              </ResponsiveMasonry>
            )}

            {active == 4 && (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 2 }}>
                <Masonry columnsCount={2} gutter={20}>
                  {testimonials
                    .filter(el => el.category == 'paidAds')
                    .map((el, ind) => {
                      if (ind < index) {
                        return (
                          <div className={'bg-gray-light md:bg-white mt-20 grid-item ' + st.item} key={'review4' + ind}>
                            <Review data={el} />
                          </div>
                        );
                      }
                    })}
                </Masonry>
              </ResponsiveMasonry>
            )}

            {active == 5 && (
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 2 }}>
                <Masonry columnsCount={2} gutter={20}>
                  {testimonials
                    .filter(el => el.category == 'design')
                    .map((el, ind) => {
                      if (ind < index) {
                        return (
                          <div className={'bg-gray-light md:bg-white mt-20 grid-item ' + st.item} key={'review5' + ind}>
                            <Review data={el} />
                          </div>
                        );
                      }
                    })}
                </Masonry>
              </ResponsiveMasonry>
            )}
          </div>
          <div className="container py-24 pt-10 md:pt-24 grid justify-end items-end">
            <span
              href="https://weprodigi.com/main/cases"
              onClick={() => {
                setIndex(index + 2);
              }}
              className={'cursor-pointer text-purple flex text-20 font-bolder leading-24' + st['hover-arrow']}
            >
              More Reviews
              <svg xmlns="http://www.w3.org/2000/svg" width={25} viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </div>
        </div>
        <div className="bg-gray-light">
          <div className="container py-24 ">
            <p className="text-black text-30 md:text-48 uppercase font-bolder leading-none">Testimonials about projects</p>
            <TestimonalsAboutProject about={aboutProjects} />
          </div>
        </div>
        <div className="bg-white">
          <div className="container py-24">
            <p className="text-black text-30 md:text-48 uppercase font-bolder leading-none">Testimonials about location</p>
            <div className="flex flex-wrap justify-between mt-24">
              <div className="w-full md:w-half-auto-2">
                <div className="font-normal text-black text-16  block md:hidden ">
                  <ViewMore ln={30}>
                    Globalization and internet availability are now erasing the physical boundaries transporting the business processes to the digital
                    world. You can be a New York-based company collaborating with a New York-based service provider, and there are chances you will
                    never meet offline for performing business processes. The idea of internal agencies is no longer relevant, meaning you can
                    collaborate with offshore agencies accepting the location as a non-priority concern. Resource and time-consuming processes are now
                    maximum simplified to direct the potential to the implementation for business objectives. Taking advantage of global
                    transformations, Prodigi has created the most reliable, stable, and faster communication processes prioritizing knowledge and
                    skills rather than location. We take care of partner experience and provide absolute cultural fit, breaking the fear of
                    outsourcing and covering a language gap with the multilingual team. The flexibility of operations offers the availability of our
                    services regardless of time zones. We have not once proven the theory by the experience of loyal customers.
                  </ViewMore>
                </div>
                <div className="font-normal text-black hidden text-16 md:block">
                  <ViewMore ln={80}>
                    Globalization and internet availability are now erasing the physical boundaries transporting the business processes to the digital
                    world. You can be a New York-based company collaborating with a New York-based service provider, and there are chances you will
                    never meet offline for performing business processes. The idea of internal agencies is no longer relevant, meaning you can
                    collaborate with offshore agencies accepting the location as a non-priority concern. Resource and time-consuming processes are now
                    maximum simplified to direct the potential to the implementation for business objectives. Taking advantage of global
                    transformations, Prodigi has created the most reliable, stable, and faster communication processes prioritizing knowledge and
                    skills rather than location. We take care of partner experience and provide absolute cultural fit, breaking the fear of
                    outsourcing and covering a language gap with the multilingual team. The flexibility of operations offers the availability of our
                    services regardless of time zones. We have not once proven the theory by the experience of loyal customers.
                  </ViewMore>
                </div>
              </div>
              <div className="w-full md:w-half-auto-2 mt-30 md:mt-0">
                <video width="100%" controls poster="https://weprodigi.com/images/about/thumbnail.jpg" className="header-mp4">
                  <source src="https://weprodigi.com/images/about/Locationdoesntmatter2.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-darkTestimonials md:bg-gray-light min-h-227 relative">
          <div className="absolute w-full -top-0 h-full flex justify-between">
            <div />
            <div className={' w-half h-full'}>
              <div className={'w-half bg-gray-light  ' + st.poligon} />
            </div>
          </div>
          <div className="container relative py-24">
            <div className="flex flex-wrap md:flex-nowrap  justify-between">
              <div className={'flex flex-col items-start'}>
                <p className="text-black text-30 md:text-48 uppercase font-bolder leading-none">case studies</p>
                <p className={'mt-24'}>If you want to be sure of our service quality check our cases.</p>
                <a
                  href="https://weprodigi.com/main/cases"
                  className={'hidden md:block px-24 mt-24 rounded-5 py-9 text-white text-18 leading-22 bg-green hover:bg-green-hover'}
                >
                  More Case Studies
                </a>
              </div>
              <img
                src="https://admin.weprodigi.com/uploads/images/testimonals/case_example.png"
                className={'self-end right-0'}
                width={536}
                alt="case_example"
              />
              <a
                href="https://weprodigi.com/main/cases"
                className={
                  'block md:hidden w-full text-center px-24 mt-24 rounded-5 py-9 text-white text-18 leading-22 bg-green hover:bg-green-hover'
                }
              >
                More Case Studies
              </a>
            </div>
          </div>
        </div>
        <Suspense fallback={<h2>Still Loading…</h2>}>
          <div className={'h-344 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
            <div id="stars" />
            <div id="stars2" />
            <div id="stars3" />
            <div className="container flex flex-col justify-evenly items-center h-full ">
              <div className={'text-center   text-white leading-37 md:leading-59 text-30 md:text-48'}>
                And if you are already here this is one more proof that we’re digital marketing heroes, so... <br />
                <div className={'flex justify-center mt-0'}>
                  <button
                    className=" h-40 text-18 leading-24  hover:bg-purple md:flex justify-center items-center w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                    onClick={() => {
                      if (window.innerWidth < 768) {
                        window.location.href = '/get-proposal?t=contact';
                      } else {
                        setHidden();
                        setShowModalPPC(true);
                        document.documentElement.style.overflow = 'hidden';
                      }
                    }}
                  >
                    Contact us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Suspense>
      </main>
      <div
        className={`fixed overlay-filter transition-all z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center ${showFilters ? ' flex' : ' hidden'} `}
        onClick={() => showFiltersFunc(false)}
      >
        <div className="menu bg-white w-90p h-full absolute left-0 text-purple z-1000">
          <div className="w-full flex justify-between items-center mt-10">
            <span className={'absolute font-bolder right-20 overlay-filter'} onClick={() => showFiltersFunc(false)}>
              X
            </span>
            <h2 className={'font-bolder text-20 pl-15 '}>Filters</h2>
          </div>
          <div className={'text-black'}>
            <div className={'mt-20'}>
              <div
                className={`flex items-center justify-between w-full text-purple bg-gray-light px-20 py-10 mb-0   `}
                onClick={() => {
                  setActive(2);
                  setShowFilters(false);
                  document.body.style.overflowY = 'auto';
                  document.body.style.overflowX = 'auto';
                }}
              >
                <p className={' text-black text-16'}>Video Production</p>
                <svg xmlns="http://www.w3.org/2000/svg" className="" width={20} viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className={'text-black'}>
            <div className={'mt-5'}>
              <div
                className={`flex items-center justify-between w-full text-purple bg-gray-light px-20 py-10 mb-0   `}
                onClick={() => {
                  setActive(3);
                  setShowFilters(false);
                  document.body.style.overflowY = 'auto';
                  document.body.style.overflowX = 'auto';
                }}
              >
                <p className={' text-black text-16'}>SMM</p>
                <svg xmlns="http://www.w3.org/2000/svg" className="" width={20} viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className={'text-black'}>
            <div className={'mt-5'}>
              <div
                className={`flex items-center justify-between w-full text-purple bg-gray-light px-20 py-10 mb-0   `}
                onClick={() => {
                  setActive(4);
                  setShowFilters(false);
                  document.body.style.overflowY = 'auto';
                  document.body.style.overflowX = 'auto';
                }}
              >
                <p className={' text-black text-16'}>Paid Advertising</p>
                <svg xmlns="http://www.w3.org/2000/svg" className="" width={20} viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className={'text-black'}>
            <div className={'mt-5'}>
              <div
                className={`flex items-center justify-between w-full text-purple bg-gray-light px-20 py-10 mb-5   `}
                onClick={() => {
                  setActive(5);
                  setShowFilters(false);
                  document.body.style.overflowY = 'auto';
                  document.body.style.overflowX = 'auto';
                }}
              >
                <p className={'  text-black text-16'}>Design</p>
                <svg xmlns="http://www.w3.org/2000/svg" className="" width={20} viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GetProposal
        from={'contact'}
        country={props.country}
        show={showModalPPC}
        id={'form-ppc'}
        hide={hideOfferModalPPC}
        website={''}
        currency={props.currency}
      />
    </>
  );
};
export default Testimonals;
